import React from 'react';
import DevelopmentInProgress from '../../../../components/common/DevelopmentInProgress';

export default function VendorCreditGeneral({ setError, error, setForm, form }) {
	return <DevelopmentInProgress />;
}
